import { Link } from 'react-router-dom';
import { stats, partners } from '@/mocks/reviews';

export default function AboutPreviewSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-4">
              关于黄瓜网站
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6 max-w-xl">
              黄瓜网站成立于2020年，是国内领先的黄瓜产业信息服务平台。我们致力于为全国黄瓜种植户、经销商和农业从业者提供最专业、最及时的技术资讯和市场数据，助力中国黄瓜产业高质量发展。
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
              {stats.map((stat, i) => (
                <div key={i} className="text-center p-3">
                  <div className="text-xl md:text-2xl font-bold text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-background-100 border border-background-200 rounded-lg p-5 md:p-6">
              <h3 className="font-heading font-semibold text-foreground-800 text-sm mb-4">
                合作伙伴
              </h3>
              <div className="space-y-3">
                {partners.map((partner, i) => (
                  <div key={i} className="flex items-center gap-3 p-3 bg-background-50 rounded-lg">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-line text-primary-500 text-sm"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{partner.name}</p>
                      <p className="text-xs text-foreground-400">{partner.type}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}